// components/ModalAddEvent.jsx
import { useState } from "react";
import Swal from "sweetalert2";

export default function ModalAddVendor({ isOpen, onClose, onAdded }) {
  const [vendorName, setVendorName] = useState("");
  const [vendorDivisi, setVendorDivisi] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!vendorName.trim()) return;

    const data = {
      name: vendorName,
      divisi: vendorDivisi,
      pic: "",
      type: "karyawan"
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/vendors/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Gagal menyimpan event");
      }

      const resData = await response.json();

      if (resData && resData.id) {
        onAdded(resData); 
      }
        Swal.fire('Berhasil', 'Karyawan berhasil ditambahkan.', 'success');
        setVendorName("");
        setVendorDivisi("");
        onClose();
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-96">
        <h2 className="text-lg font-semibold mb-4">Tambah Karyawan</h2>
        <form onSubmit={handleSubmit}>
          <label>Nama Karyawan</label>
          <input
            type="text"
            required
            className="w-full border p-2 rounded"
            value={vendorName}
            onChange={(e) => setVendorName(e.target.value)}
          />
          <h1 className="text-xs text-red-500 mb-4">Nama Lengkap sesuai dengan Nama di aplikasi Talenta, bukan nama panggilan saja.</h1>
          <label>Divisi</label>
          <input
            type="text"
            required
            className="w-full border p-2 rounded mb-4"
            value={vendorDivisi}
            onChange={(e) => setVendorDivisi(e.target.value)}
          />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="text-gray-500">Batal</button>
            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
              Simpan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
